/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from '../API';
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const setQmFeatureFlags = /* GraphQL */ `mutation SetQmFeatureFlags($input: SetQmFeatureFlagsInput!) {
  setQmFeatureFlags(input: $input) {
    qmNewDashboardEnabled
    qmSiteInboundEnabled
    __typename
  }
}
` as GeneratedMutation<APITypes.SetQmFeatureFlagsMutationVariables, APITypes.SetQmFeatureFlagsMutation>;
export const saveReceiveManifestSnapshot = /* GraphQL */ `mutation SaveReceiveManifestSnapshot($body: String!) {
  saveReceiveManifestSnapshot(body: $body)
}
` as GeneratedMutation<
  APITypes.SaveReceiveManifestSnapshotMutationVariables,
  APITypes.SaveReceiveManifestSnapshotMutation
>;
export const saveManifestPartialReceipt =
  /* GraphQL */ `mutation SaveManifestPartialReceipt($input: SaveManifestPartialReceiptInput!) {
  saveManifestPartialReceipt(input: $input) {
    manifestId
    lines {
      id
      sessionId
      manifestId
      triggeredBy
      asn
      poLineId
      itemId
      sourcePartId
      lineDescription
      packageId
      selectedForReceive
      requestedQuantity
      processedQuantity
      receiveQuantity
      packageQuantity
      orderedQuantity
      receivedQuantity
      status
      errorCode
      errorMessage
      processedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
    APITypes.SaveManifestPartialReceiptMutationVariables,
    APITypes.SaveManifestPartialReceiptMutation
  >;
export const createQmRecord = /* GraphQL */ `mutation CreateQmRecord($input: CreateQmRecordInput!) {
  createQmRecord(input: $input) {
    qmId
    qmNumber
    type
    typeLabel
    status
    reasonCode
    reasonLabel
    closureCode
    closureLabel
    sscc
    asn
    tripId
    tripReference
    manifestId
    poNumber
    poLine
    poLineId
    itemId
    supplierCode
    supplierName
    contactName
    itemLocation
    packageCount
    packageType
    otherInformation
    description
    closureNotes
    createdBy
    createdAt
    updatedBy
    updatedAt
    closedAt
    statusHistory {
      id
      fromStatus
      toStatus
      changedBy
      changedAt
      note
      __typename
    }
    changeHistory {
      id
      fieldName
      oldValue
      newValue
      changedBy
      changedAt
      __typename
    }
    comments {
      id
      body
      createdBy
      createdAt
      __typename
    }
    poLines {
      lineIndex
      poLineId
      poLine
      itemId
      linePayload
      orderedQuantity
      receivedQuantity
      quantityVariance
      __typename
    }
    packages {
      packageNumber
      packageType
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<APITypes.CreateQmRecordMutationVariables, APITypes.CreateQmRecordMutation>;
export const updateQmRecord = /* GraphQL */ `mutation UpdateQmRecord($input: UpdateQmRecordInput!) {
  updateQmRecord(input: $input) {
    qmId
    qmNumber
    type
    typeLabel
    status
    reasonCode
    reasonLabel
    closureCode
    closureLabel
    sscc
    asn
    tripId
    tripReference
    manifestId
    poNumber
    poLine
    poLineId
    itemId
    supplierCode
    supplierName
    contactName
    itemLocation
    packageCount
    packageType
    otherInformation
    description
    closureNotes
    createdBy
    createdAt
    updatedBy
    updatedAt
    closedAt
    statusHistory {
      id
      fromStatus
      toStatus
      changedBy
      changedAt
      note
      __typename
    }
    changeHistory {
      id
      fieldName
      oldValue
      newValue
      changedBy
      changedAt
      __typename
    }
    comments {
      id
      body
      createdBy
      createdAt
      __typename
    }
    poLines {
      lineIndex
      poLineId
      poLine
      itemId
      linePayload
      orderedQuantity
      receivedQuantity
      quantityVariance
      __typename
    }
    packages {
      packageNumber
      packageType
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<APITypes.UpdateQmRecordMutationVariables, APITypes.UpdateQmRecordMutation>;
export const createQmReferenceLocation =
  /* GraphQL */ `mutation CreateQmReferenceLocation($input: CreateQmLocationInput!) {
  createQmReferenceLocation(input: $input) {
    code
    label
    displayOrder
    active
    __typename
  }
}
` as GeneratedMutation<APITypes.CreateQmReferenceLocationMutationVariables, APITypes.CreateQmReferenceLocationMutation>;
export const updateQmReferenceLocation =
  /* GraphQL */ `mutation UpdateQmReferenceLocation($input: UpdateQmLocationInput!) {
  updateQmReferenceLocation(input: $input) {
    code
    label
    displayOrder
    active
    __typename
  }
}
` as GeneratedMutation<APITypes.UpdateQmReferenceLocationMutationVariables, APITypes.UpdateQmReferenceLocationMutation>;
export const archiveQmReferenceLocation =
  /* GraphQL */ `mutation ArchiveQmReferenceLocation($input: ArchiveQmLocationInput!) {
  archiveQmReferenceLocation(input: $input) {
    code
    label
    displayOrder
    active
    __typename
  }
}
` as GeneratedMutation<
    APITypes.ArchiveQmReferenceLocationMutationVariables,
    APITypes.ArchiveQmReferenceLocationMutation
  >;
export const createQmSiteInboundWarehouse = /* GraphQL */ `mutation CreateQmSiteInboundWarehouse(
  $input: CreateQmSiteInboundWarehouseInput!
) {
  createQmSiteInboundWarehouse(input: $input) {
    receivingWarehouseId
    label
    qmCoordinatorEmails
    displayOrder
    active
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateQmSiteInboundWarehouseMutationVariables,
  APITypes.CreateQmSiteInboundWarehouseMutation
>;
export const updateQmSiteInboundWarehouse = /* GraphQL */ `mutation UpdateQmSiteInboundWarehouse(
  $input: UpdateQmSiteInboundWarehouseInput!
) {
  updateQmSiteInboundWarehouse(input: $input) {
    receivingWarehouseId
    label
    qmCoordinatorEmails
    displayOrder
    active
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateQmSiteInboundWarehouseMutationVariables,
  APITypes.UpdateQmSiteInboundWarehouseMutation
>;
export const archiveQmSiteInboundWarehouse = /* GraphQL */ `mutation ArchiveQmSiteInboundWarehouse(
  $input: ArchiveQmSiteInboundWarehouseInput!
) {
  archiveQmSiteInboundWarehouse(input: $input) {
    receivingWarehouseId
    label
    qmCoordinatorEmails
    displayOrder
    active
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ArchiveQmSiteInboundWarehouseMutationVariables,
  APITypes.ArchiveQmSiteInboundWarehouseMutation
>;
export const setQmSiteInboundWarehouseUserRoles = /* GraphQL */ `mutation SetQmSiteInboundWarehouseUserRoles(
  $input: SetQmSiteInboundWarehouseUserRolesInput!
) {
  setQmSiteInboundWarehouseUserRoles(input: $input) {
    receivingWarehouseId
    receivingWarehouseLabel
    userEmail
    userCognitoId
    role
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SetQmSiteInboundWarehouseUserRolesMutationVariables,
  APITypes.SetQmSiteInboundWarehouseUserRolesMutation
>;
export const createQmSiteInboundLocation = /* GraphQL */ `mutation CreateQmSiteInboundLocation(
  $input: CreateQmSiteInboundLocationInput!
) {
  createQmSiteInboundLocation(input: $input) {
    receivingWarehouseId
    receivingWarehouseLabel
    code
    label
    displayOrder
    active
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateQmSiteInboundLocationMutationVariables,
  APITypes.CreateQmSiteInboundLocationMutation
>;
export const updateQmSiteInboundLocation = /* GraphQL */ `mutation UpdateQmSiteInboundLocation(
  $input: UpdateQmSiteInboundLocationInput!
) {
  updateQmSiteInboundLocation(input: $input) {
    receivingWarehouseId
    receivingWarehouseLabel
    code
    label
    displayOrder
    active
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateQmSiteInboundLocationMutationVariables,
  APITypes.UpdateQmSiteInboundLocationMutation
>;
export const archiveQmSiteInboundLocation = /* GraphQL */ `mutation ArchiveQmSiteInboundLocation(
  $input: ArchiveQmSiteInboundLocationInput!
) {
  archiveQmSiteInboundLocation(input: $input) {
    receivingWarehouseId
    receivingWarehouseLabel
    code
    label
    displayOrder
    active
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ArchiveQmSiteInboundLocationMutationVariables,
  APITypes.ArchiveQmSiteInboundLocationMutation
>;
export const addQmComment = /* GraphQL */ `mutation AddQmComment($input: AddQmCommentInput!) {
  addQmComment(input: $input) {
    qmId
    qmNumber
    type
    typeLabel
    status
    reasonCode
    reasonLabel
    closureCode
    closureLabel
    sscc
    asn
    tripId
    tripReference
    manifestId
    poNumber
    poLine
    poLineId
    itemId
    supplierCode
    supplierName
    contactName
    itemLocation
    packageCount
    packageType
    otherInformation
    description
    closureNotes
    createdBy
    createdAt
    updatedBy
    updatedAt
    closedAt
    statusHistory {
      id
      fromStatus
      toStatus
      changedBy
      changedAt
      note
      __typename
    }
    changeHistory {
      id
      fieldName
      oldValue
      newValue
      changedBy
      changedAt
      __typename
    }
    comments {
      id
      body
      createdBy
      createdAt
      __typename
    }
    poLines {
      lineIndex
      poLineId
      poLine
      itemId
      linePayload
      orderedQuantity
      receivedQuantity
      quantityVariance
      __typename
    }
    packages {
      packageNumber
      packageType
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<APITypes.AddQmCommentMutationVariables, APITypes.AddQmCommentMutation>;
export const confirmAttachment = /* GraphQL */ `mutation ConfirmAttachment($input: ConfirmAttachmentInput!) {
  confirmAttachment(input: $input) {
    id
    qmId
    fileName
    mimeType
    sizeBytes
    uploadedBy
    uploadedAt
    downloadUrl
    __typename
  }
}
` as GeneratedMutation<APITypes.ConfirmAttachmentMutationVariables, APITypes.ConfirmAttachmentMutation>;
export const publishQmLiveUpdate = /* GraphQL */ `mutation PublishQmLiveUpdate($input: PublishQmLiveUpdateInput!) {
  publishQmLiveUpdate(input: $input) {
    qmId
    qmNumber
    type
    typeLabel
    status
    reasonCode
    reasonLabel
    closureCode
    closureLabel
    sscc
    asn
    tripId
    tripReference
    manifestId
    poNumber
    poLine
    poLineId
    itemId
    supplierCode
    supplierName
    contactName
    itemLocation
    packageCount
    packageType
    otherInformation
    description
    closureNotes
    createdBy
    createdAt
    updatedBy
    updatedAt
    closedAt
    statusHistory {
      id
      fromStatus
      toStatus
      changedBy
      changedAt
      note
      __typename
    }
    changeHistory {
      id
      fieldName
      oldValue
      newValue
      changedBy
      changedAt
      __typename
    }
    comments {
      id
      body
      createdBy
      createdAt
      __typename
    }
    poLines {
      lineIndex
      poLineId
      poLine
      itemId
      linePayload
      orderedQuantity
      receivedQuantity
      quantityVariance
      __typename
    }
    packages {
      packageNumber
      packageType
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<APITypes.PublishQmLiveUpdateMutationVariables, APITypes.PublishQmLiveUpdateMutation>;
export const createUserDetails = /* GraphQL */ `mutation CreateUserDetails(
  $input: CreateUserDetailsInput!
  $condition: ModelUserDetailsConditionInput
) {
  createUserDetails(input: $input, condition: $condition) {
    id
    cognitoID
    printer {
      id
      name
      printerIP
      printerPort
      isDisabled
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    location {
      id
      type
      name
      alias
      address
      suburb
      state
      postcode
      contactName
      contactPhone
      isDisabled
      isAutoReceipt
      deliveryDays
      parentLocationId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      locationUserDetailsId
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    userDetailsPrinterId
    userDetailsLocationId
    owner
    __typename
  }
}
` as GeneratedMutation<APITypes.CreateUserDetailsMutationVariables, APITypes.CreateUserDetailsMutation>;
export const updateUserDetails = /* GraphQL */ `mutation UpdateUserDetails(
  $input: UpdateUserDetailsInput!
  $condition: ModelUserDetailsConditionInput
) {
  updateUserDetails(input: $input, condition: $condition) {
    id
    cognitoID
    printer {
      id
      name
      printerIP
      printerPort
      isDisabled
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    location {
      id
      type
      name
      alias
      address
      suburb
      state
      postcode
      contactName
      contactPhone
      isDisabled
      isAutoReceipt
      deliveryDays
      parentLocationId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      locationUserDetailsId
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    userDetailsPrinterId
    userDetailsLocationId
    owner
    __typename
  }
}
` as GeneratedMutation<APITypes.UpdateUserDetailsMutationVariables, APITypes.UpdateUserDetailsMutation>;
export const deleteUserDetails = /* GraphQL */ `mutation DeleteUserDetails(
  $input: DeleteUserDetailsInput!
  $condition: ModelUserDetailsConditionInput
) {
  deleteUserDetails(input: $input, condition: $condition) {
    id
    cognitoID
    printer {
      id
      name
      printerIP
      printerPort
      isDisabled
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    location {
      id
      type
      name
      alias
      address
      suburb
      state
      postcode
      contactName
      contactPhone
      isDisabled
      isAutoReceipt
      deliveryDays
      parentLocationId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      locationUserDetailsId
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    userDetailsPrinterId
    userDetailsLocationId
    owner
    __typename
  }
}
` as GeneratedMutation<APITypes.DeleteUserDetailsMutationVariables, APITypes.DeleteUserDetailsMutation>;
export const createUserProfile = /* GraphQL */ `mutation CreateUserProfile(
  $input: CreateUserProfileInput!
  $condition: ModelUserProfileConditionInput
) {
  createUserProfile(input: $input, condition: $condition) {
    cognitoID
    email
    firstname
    lastname
    adminPanelAccess
    qmListRole
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.CreateUserProfileMutationVariables, APITypes.CreateUserProfileMutation>;
export const updateUserProfile = /* GraphQL */ `mutation UpdateUserProfile(
  $input: UpdateUserProfileInput!
  $condition: ModelUserProfileConditionInput
) {
  updateUserProfile(input: $input, condition: $condition) {
    cognitoID
    email
    firstname
    lastname
    adminPanelAccess
    qmListRole
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.UpdateUserProfileMutationVariables, APITypes.UpdateUserProfileMutation>;
export const deleteUserProfile = /* GraphQL */ `mutation DeleteUserProfile(
  $input: DeleteUserProfileInput!
  $condition: ModelUserProfileConditionInput
) {
  deleteUserProfile(input: $input, condition: $condition) {
    cognitoID
    email
    firstname
    lastname
    adminPanelAccess
    qmListRole
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.DeleteUserProfileMutationVariables, APITypes.DeleteUserProfileMutation>;
export const createPrinter = /* GraphQL */ `mutation CreatePrinter(
  $input: CreatePrinterInput!
  $condition: ModelPrinterConditionInput
) {
  createPrinter(input: $input, condition: $condition) {
    id
    name
    printerIP
    printerPort
    isDisabled
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.CreatePrinterMutationVariables, APITypes.CreatePrinterMutation>;
export const updatePrinter = /* GraphQL */ `mutation UpdatePrinter(
  $input: UpdatePrinterInput!
  $condition: ModelPrinterConditionInput
) {
  updatePrinter(input: $input, condition: $condition) {
    id
    name
    printerIP
    printerPort
    isDisabled
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.UpdatePrinterMutationVariables, APITypes.UpdatePrinterMutation>;
export const deletePrinter = /* GraphQL */ `mutation DeletePrinter(
  $input: DeletePrinterInput!
  $condition: ModelPrinterConditionInput
) {
  deletePrinter(input: $input, condition: $condition) {
    id
    name
    printerIP
    printerPort
    isDisabled
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.DeletePrinterMutationVariables, APITypes.DeletePrinterMutation>;
export const createPackageType = /* GraphQL */ `mutation CreatePackageType(
  $input: CreatePackageTypeInput!
  $condition: ModelPackageTypeConditionInput
) {
  createPackageType(input: $input, condition: $condition) {
    id
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.CreatePackageTypeMutationVariables, APITypes.CreatePackageTypeMutation>;
export const updatePackageType = /* GraphQL */ `mutation UpdatePackageType(
  $input: UpdatePackageTypeInput!
  $condition: ModelPackageTypeConditionInput
) {
  updatePackageType(input: $input, condition: $condition) {
    id
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.UpdatePackageTypeMutationVariables, APITypes.UpdatePackageTypeMutation>;
export const deletePackageType = /* GraphQL */ `mutation DeletePackageType(
  $input: DeletePackageTypeInput!
  $condition: ModelPackageTypeConditionInput
) {
  deletePackageType(input: $input, condition: $condition) {
    id
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.DeletePackageTypeMutationVariables, APITypes.DeletePackageTypeMutation>;
export const createQMReason = /* GraphQL */ `mutation CreateQMReason(
  $input: CreateQMReasonInput!
  $condition: ModelQMReasonConditionInput
) {
  createQMReason(input: $input, condition: $condition) {
    id
    reasonId
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.CreateQMReasonMutationVariables, APITypes.CreateQMReasonMutation>;
export const updateQMReason = /* GraphQL */ `mutation UpdateQMReason(
  $input: UpdateQMReasonInput!
  $condition: ModelQMReasonConditionInput
) {
  updateQMReason(input: $input, condition: $condition) {
    id
    reasonId
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.UpdateQMReasonMutationVariables, APITypes.UpdateQMReasonMutation>;
export const deleteQMReason = /* GraphQL */ `mutation DeleteQMReason(
  $input: DeleteQMReasonInput!
  $condition: ModelQMReasonConditionInput
) {
  deleteQMReason(input: $input, condition: $condition) {
    id
    reasonId
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.DeleteQMReasonMutationVariables, APITypes.DeleteQMReasonMutation>;
export const createWorkflowStatus = /* GraphQL */ `mutation CreateWorkflowStatus(
  $input: CreateWorkflowStatusInput!
  $condition: ModelWorkflowStatusConditionInput
) {
  createWorkflowStatus(input: $input, condition: $condition) {
    id
    workflowStatusId
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.CreateWorkflowStatusMutationVariables, APITypes.CreateWorkflowStatusMutation>;
export const updateWorkflowStatus = /* GraphQL */ `mutation UpdateWorkflowStatus(
  $input: UpdateWorkflowStatusInput!
  $condition: ModelWorkflowStatusConditionInput
) {
  updateWorkflowStatus(input: $input, condition: $condition) {
    id
    workflowStatusId
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.UpdateWorkflowStatusMutationVariables, APITypes.UpdateWorkflowStatusMutation>;
export const deleteWorkflowStatus = /* GraphQL */ `mutation DeleteWorkflowStatus(
  $input: DeleteWorkflowStatusInput!
  $condition: ModelWorkflowStatusConditionInput
) {
  deleteWorkflowStatus(input: $input, condition: $condition) {
    id
    workflowStatusId
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.DeleteWorkflowStatusMutationVariables, APITypes.DeleteWorkflowStatusMutation>;
export const createQMIssue = /* GraphQL */ `mutation CreateQMIssue(
  $input: CreateQMIssueInput!
  $condition: ModelQMIssueConditionInput
) {
  createQMIssue(input: $input, condition: $condition) {
    id
    issueId
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.CreateQMIssueMutationVariables, APITypes.CreateQMIssueMutation>;
export const updateQMIssue = /* GraphQL */ `mutation UpdateQMIssue(
  $input: UpdateQMIssueInput!
  $condition: ModelQMIssueConditionInput
) {
  updateQMIssue(input: $input, condition: $condition) {
    id
    issueId
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.UpdateQMIssueMutationVariables, APITypes.UpdateQMIssueMutation>;
export const deleteQMIssue = /* GraphQL */ `mutation DeleteQMIssue(
  $input: DeleteQMIssueInput!
  $condition: ModelQMIssueConditionInput
) {
  deleteQMIssue(input: $input, condition: $condition) {
    id
    issueId
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.DeleteQMIssueMutationVariables, APITypes.DeleteQMIssueMutation>;
export const createRemoveItemSSCCHistory = /* GraphQL */ `mutation CreateRemoveItemSSCCHistory(
  $input: CreateRemoveItemSSCCHistoryInput!
  $condition: ModelRemoveItemSSCCHistoryConditionInput
) {
  createRemoveItemSSCCHistory(input: $input, condition: $condition) {
    id
    userEmail
    reason
    originSSCC
    destinationSSCC
    asn
    actionTime
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRemoveItemSSCCHistoryMutationVariables,
  APITypes.CreateRemoveItemSSCCHistoryMutation
>;
export const updateRemoveItemSSCCHistory = /* GraphQL */ `mutation UpdateRemoveItemSSCCHistory(
  $input: UpdateRemoveItemSSCCHistoryInput!
  $condition: ModelRemoveItemSSCCHistoryConditionInput
) {
  updateRemoveItemSSCCHistory(input: $input, condition: $condition) {
    id
    userEmail
    reason
    originSSCC
    destinationSSCC
    asn
    actionTime
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRemoveItemSSCCHistoryMutationVariables,
  APITypes.UpdateRemoveItemSSCCHistoryMutation
>;
export const deleteRemoveItemSSCCHistory = /* GraphQL */ `mutation DeleteRemoveItemSSCCHistory(
  $input: DeleteRemoveItemSSCCHistoryInput!
  $condition: ModelRemoveItemSSCCHistoryConditionInput
) {
  deleteRemoveItemSSCCHistory(input: $input, condition: $condition) {
    id
    userEmail
    reason
    originSSCC
    destinationSSCC
    asn
    actionTime
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRemoveItemSSCCHistoryMutationVariables,
  APITypes.DeleteRemoveItemSSCCHistoryMutation
>;
export const createReceiptEventPackageHistory = /* GraphQL */ `mutation CreateReceiptEventPackageHistory(
  $input: CreateReceiptEventPackageHistoryInput!
  $condition: ModelReceiptEventPackageHistoryConditionInput
) {
  createReceiptEventPackageHistory(input: $input, condition: $condition) {
    id
    asn
    receiptType
    associatedSSCC
    receiptedBy
    actionTime
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateReceiptEventPackageHistoryMutationVariables,
  APITypes.CreateReceiptEventPackageHistoryMutation
>;
export const updateReceiptEventPackageHistory = /* GraphQL */ `mutation UpdateReceiptEventPackageHistory(
  $input: UpdateReceiptEventPackageHistoryInput!
  $condition: ModelReceiptEventPackageHistoryConditionInput
) {
  updateReceiptEventPackageHistory(input: $input, condition: $condition) {
    id
    asn
    receiptType
    associatedSSCC
    receiptedBy
    actionTime
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateReceiptEventPackageHistoryMutationVariables,
  APITypes.UpdateReceiptEventPackageHistoryMutation
>;
export const deleteReceiptEventPackageHistory = /* GraphQL */ `mutation DeleteReceiptEventPackageHistory(
  $input: DeleteReceiptEventPackageHistoryInput!
  $condition: ModelReceiptEventPackageHistoryConditionInput
) {
  deleteReceiptEventPackageHistory(input: $input, condition: $condition) {
    id
    asn
    receiptType
    associatedSSCC
    receiptedBy
    actionTime
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteReceiptEventPackageHistoryMutationVariables,
  APITypes.DeleteReceiptEventPackageHistoryMutation
>;
export const createAdminActionHistory = /* GraphQL */ `mutation CreateAdminActionHistory(
  $input: CreateAdminActionHistoryInput!
  $condition: ModelAdminActionHistoryConditionInput
) {
  createAdminActionHistory(input: $input, condition: $condition) {
    id
    actionType
    beforeAction
    afterAction
    actionBy
    actionTime
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.CreateAdminActionHistoryMutationVariables, APITypes.CreateAdminActionHistoryMutation>;
export const updateAdminActionHistory = /* GraphQL */ `mutation UpdateAdminActionHistory(
  $input: UpdateAdminActionHistoryInput!
  $condition: ModelAdminActionHistoryConditionInput
) {
  updateAdminActionHistory(input: $input, condition: $condition) {
    id
    actionType
    beforeAction
    afterAction
    actionBy
    actionTime
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.UpdateAdminActionHistoryMutationVariables, APITypes.UpdateAdminActionHistoryMutation>;
export const deleteAdminActionHistory = /* GraphQL */ `mutation DeleteAdminActionHistory(
  $input: DeleteAdminActionHistoryInput!
  $condition: ModelAdminActionHistoryConditionInput
) {
  deleteAdminActionHistory(input: $input, condition: $condition) {
    id
    actionType
    beforeAction
    afterAction
    actionBy
    actionTime
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.DeleteAdminActionHistoryMutationVariables, APITypes.DeleteAdminActionHistoryMutation>;
export const createSSCC = /* GraphQL */ `mutation CreateSSCC(
  $input: CreateSSCCInput!
  $condition: ModelSSCCConditionInput
) {
  createSSCC(input: $input, condition: $condition) {
    id
    nickname
    originLocationId
    originLocation {
      id
      type
      name
      alias
      address
      suburb
      state
      postcode
      contactName
      contactPhone
      isDisabled
      isAutoReceipt
      deliveryDays
      parentLocationId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      locationUserDetailsId
      __typename
    }
    destinationLocationId
    destinationLocation {
      id
      type
      name
      alias
      address
      suburb
      state
      postcode
      contactName
      contactPhone
      isDisabled
      isAutoReceipt
      deliveryDays
      parentLocationId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      locationUserDetailsId
      __typename
    }
    lock
    status
    isLargeItem
    isTransportBooking
    transportBookingDestination {
      businessName
      addressLine1
      addressLine2
      suburb
      state
      postCode
      contactName
      contactNumber
      emailAddress
      __typename
    }
    bustleServiceType
    ssccType
    height
    width
    depth
    weight
    estimatedDelivery
    open
    staged
    manifested
    inTransit
    approaching
    delivered
    createdAt
    updatedAt
    stagingLocation
    receiptedEvents {
      name
      site
      __typename
    }
    _version
    _deleted
    _lastChangedAt
    locationSsccsId
    __typename
  }
}
` as GeneratedMutation<APITypes.CreateSSCCMutationVariables, APITypes.CreateSSCCMutation>;
export const updateSSCC = /* GraphQL */ `mutation UpdateSSCC(
  $input: UpdateSSCCInput!
  $condition: ModelSSCCConditionInput
) {
  updateSSCC(input: $input, condition: $condition) {
    id
    nickname
    originLocationId
    originLocation {
      id
      type
      name
      alias
      address
      suburb
      state
      postcode
      contactName
      contactPhone
      isDisabled
      isAutoReceipt
      deliveryDays
      parentLocationId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      locationUserDetailsId
      __typename
    }
    destinationLocationId
    destinationLocation {
      id
      type
      name
      alias
      address
      suburb
      state
      postcode
      contactName
      contactPhone
      isDisabled
      isAutoReceipt
      deliveryDays
      parentLocationId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      locationUserDetailsId
      __typename
    }
    lock
    status
    isLargeItem
    isTransportBooking
    transportBookingDestination {
      businessName
      addressLine1
      addressLine2
      suburb
      state
      postCode
      contactName
      contactNumber
      emailAddress
      __typename
    }
    bustleServiceType
    ssccType
    height
    width
    depth
    weight
    estimatedDelivery
    open
    staged
    manifested
    inTransit
    approaching
    delivered
    createdAt
    updatedAt
    stagingLocation
    receiptedEvents {
      name
      site
      __typename
    }
    _version
    _deleted
    _lastChangedAt
    locationSsccsId
    __typename
  }
}
` as GeneratedMutation<APITypes.UpdateSSCCMutationVariables, APITypes.UpdateSSCCMutation>;
export const deleteSSCC = /* GraphQL */ `mutation DeleteSSCC(
  $input: DeleteSSCCInput!
  $condition: ModelSSCCConditionInput
) {
  deleteSSCC(input: $input, condition: $condition) {
    id
    nickname
    originLocationId
    originLocation {
      id
      type
      name
      alias
      address
      suburb
      state
      postcode
      contactName
      contactPhone
      isDisabled
      isAutoReceipt
      deliveryDays
      parentLocationId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      locationUserDetailsId
      __typename
    }
    destinationLocationId
    destinationLocation {
      id
      type
      name
      alias
      address
      suburb
      state
      postcode
      contactName
      contactPhone
      isDisabled
      isAutoReceipt
      deliveryDays
      parentLocationId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      locationUserDetailsId
      __typename
    }
    lock
    status
    isLargeItem
    isTransportBooking
    transportBookingDestination {
      businessName
      addressLine1
      addressLine2
      suburb
      state
      postCode
      contactName
      contactNumber
      emailAddress
      __typename
    }
    bustleServiceType
    ssccType
    height
    width
    depth
    weight
    estimatedDelivery
    open
    staged
    manifested
    inTransit
    approaching
    delivered
    createdAt
    updatedAt
    stagingLocation
    receiptedEvents {
      name
      site
      __typename
    }
    _version
    _deleted
    _lastChangedAt
    locationSsccsId
    __typename
  }
}
` as GeneratedMutation<APITypes.DeleteSSCCMutationVariables, APITypes.DeleteSSCCMutation>;
export const createLocation = /* GraphQL */ `mutation CreateLocation(
  $input: CreateLocationInput!
  $condition: ModelLocationConditionInput
) {
  createLocation(input: $input, condition: $condition) {
    id
    userDetails {
      id
      cognitoID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userDetailsPrinterId
      userDetailsLocationId
      owner
      __typename
    }
    type
    name
    alias
    address
    suburb
    state
    postcode
    contactName
    contactPhone
    isDisabled
    isAutoReceipt
    deliveryDays
    originSsccs {
      nextToken
      startedAt
      __typename
    }
    destinationSsccs {
      nextToken
      startedAt
      __typename
    }
    ssccs {
      nextToken
      startedAt
      __typename
    }
    subLocations {
      nextToken
      startedAt
      __typename
    }
    parentLocationId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    locationUserDetailsId
    __typename
  }
}
` as GeneratedMutation<APITypes.CreateLocationMutationVariables, APITypes.CreateLocationMutation>;
export const updateLocation = /* GraphQL */ `mutation UpdateLocation(
  $input: UpdateLocationInput!
  $condition: ModelLocationConditionInput
) {
  updateLocation(input: $input, condition: $condition) {
    id
    userDetails {
      id
      cognitoID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userDetailsPrinterId
      userDetailsLocationId
      owner
      __typename
    }
    type
    name
    alias
    address
    suburb
    state
    postcode
    contactName
    contactPhone
    isDisabled
    isAutoReceipt
    deliveryDays
    originSsccs {
      nextToken
      startedAt
      __typename
    }
    destinationSsccs {
      nextToken
      startedAt
      __typename
    }
    ssccs {
      nextToken
      startedAt
      __typename
    }
    subLocations {
      nextToken
      startedAt
      __typename
    }
    parentLocationId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    locationUserDetailsId
    __typename
  }
}
` as GeneratedMutation<APITypes.UpdateLocationMutationVariables, APITypes.UpdateLocationMutation>;
export const deleteLocation = /* GraphQL */ `mutation DeleteLocation(
  $input: DeleteLocationInput!
  $condition: ModelLocationConditionInput
) {
  deleteLocation(input: $input, condition: $condition) {
    id
    userDetails {
      id
      cognitoID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userDetailsPrinterId
      userDetailsLocationId
      owner
      __typename
    }
    type
    name
    alias
    address
    suburb
    state
    postcode
    contactName
    contactPhone
    isDisabled
    isAutoReceipt
    deliveryDays
    originSsccs {
      nextToken
      startedAt
      __typename
    }
    destinationSsccs {
      nextToken
      startedAt
      __typename
    }
    ssccs {
      nextToken
      startedAt
      __typename
    }
    subLocations {
      nextToken
      startedAt
      __typename
    }
    parentLocationId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    locationUserDetailsId
    __typename
  }
}
` as GeneratedMutation<APITypes.DeleteLocationMutationVariables, APITypes.DeleteLocationMutation>;
export const createTripSheet = /* GraphQL */ `mutation CreateTripSheet(
  $input: CreateTripSheetInput!
  $condition: ModelTripSheetConditionInput
) {
  createTripSheet(input: $input, condition: $condition) {
    id
    carrier {
      organisation
      businessName
      name
      number
      contractor
      driver
      secondaryDriver
      __typename
    }
    reference
    createdAt
    updatedAt
    legs {
      id
      status
      departureDate
      arrivalDate
      loadingDemurrage
      unloadingDemurrage
      __typename
    }
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.CreateTripSheetMutationVariables, APITypes.CreateTripSheetMutation>;
export const updateTripSheet = /* GraphQL */ `mutation UpdateTripSheet(
  $input: UpdateTripSheetInput!
  $condition: ModelTripSheetConditionInput
) {
  updateTripSheet(input: $input, condition: $condition) {
    id
    carrier {
      organisation
      businessName
      name
      number
      contractor
      driver
      secondaryDriver
      __typename
    }
    reference
    createdAt
    updatedAt
    legs {
      id
      status
      departureDate
      arrivalDate
      loadingDemurrage
      unloadingDemurrage
      __typename
    }
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.UpdateTripSheetMutationVariables, APITypes.UpdateTripSheetMutation>;
export const deleteTripSheet = /* GraphQL */ `mutation DeleteTripSheet(
  $input: DeleteTripSheetInput!
  $condition: ModelTripSheetConditionInput
) {
  deleteTripSheet(input: $input, condition: $condition) {
    id
    carrier {
      organisation
      businessName
      name
      number
      contractor
      driver
      secondaryDriver
      __typename
    }
    reference
    createdAt
    updatedAt
    legs {
      id
      status
      departureDate
      arrivalDate
      loadingDemurrage
      unloadingDemurrage
      __typename
    }
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.DeleteTripSheetMutationVariables, APITypes.DeleteTripSheetMutation>;
export const createTransportBookingEvent = /* GraphQL */ `mutation CreateTransportBookingEvent(
  $input: CreateTransportBookingEventInput!
  $condition: ModelTransportBookingEventConditionInput
) {
  createTransportBookingEvent(input: $input, condition: $condition) {
    id
    poNumber
    destinationLocation {
      businessName
      addressLine1
      addressLine2
      suburb
      state
      postCode
      contactName
      contactNumber
      emailAddress
      __typename
    }
    originLocation {
      businessName
      addressLine1
      addressLine2
      suburb
      state
      postCode
      contactName
      contactNumber
      emailAddress
      __typename
    }
    additionalField1
    additionalField2
    additionalField3
    notesContent
    serviceType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTransportBookingEventMutationVariables,
  APITypes.CreateTransportBookingEventMutation
>;
export const updateTransportBookingEvent = /* GraphQL */ `mutation UpdateTransportBookingEvent(
  $input: UpdateTransportBookingEventInput!
  $condition: ModelTransportBookingEventConditionInput
) {
  updateTransportBookingEvent(input: $input, condition: $condition) {
    id
    poNumber
    destinationLocation {
      businessName
      addressLine1
      addressLine2
      suburb
      state
      postCode
      contactName
      contactNumber
      emailAddress
      __typename
    }
    originLocation {
      businessName
      addressLine1
      addressLine2
      suburb
      state
      postCode
      contactName
      contactNumber
      emailAddress
      __typename
    }
    additionalField1
    additionalField2
    additionalField3
    notesContent
    serviceType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTransportBookingEventMutationVariables,
  APITypes.UpdateTransportBookingEventMutation
>;
export const deleteTransportBookingEvent = /* GraphQL */ `mutation DeleteTransportBookingEvent(
  $input: DeleteTransportBookingEventInput!
  $condition: ModelTransportBookingEventConditionInput
) {
  deleteTransportBookingEvent(input: $input, condition: $condition) {
    id
    poNumber
    destinationLocation {
      businessName
      addressLine1
      addressLine2
      suburb
      state
      postCode
      contactName
      contactNumber
      emailAddress
      __typename
    }
    originLocation {
      businessName
      addressLine1
      addressLine2
      suburb
      state
      postCode
      contactName
      contactNumber
      emailAddress
      __typename
    }
    additionalField1
    additionalField2
    additionalField3
    notesContent
    serviceType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTransportBookingEventMutationVariables,
  APITypes.DeleteTransportBookingEventMutation
>;
